{
  "changeChain": {
    "title": "Sélectionnez une chaîne"
  },
  "checkoutBlocked": {
    "notAvailable": "Non disponible",
    "regionMessage": "Ce service n'est pas disponible dans votre région.",
    "viewRegions": "Voir les régions disponibles."
  },
  "common": {
    "addressCopied": "Adresse copiée",
    "back": "Retour",
    "cancel": "Annuler",
    "close": "Fermer",
    "confirm": "Confirmer",
    "continue": "Continuer",
    "copied": "Copié !",
    "copy": "Copier",
    "copyAddress": "Copier l'adresse",
    "done": "Terminé",
    "go": "Aller",
    "loading": "Chargement…",
    "ok": "OK",
    "poweredBy": "propulsé par",
    "tryAgain": "Réessayer",
    "startOver": "Recommencer"
  },
  "depositAmount": {
    "amountLabel": "Montant",
    "changeToMaximum": "Passer au maximum",
    "changeToMinimum": "Passer au minimum",
    "delete": "Supprimer",
    "enterAmount": "Saisissez un montant",
    "fee": "Frais de {{amount}}",
    "maximumAmount": "Dépôt maximum {{amount}}",
    "minimumAmount": "Dépôt minimum {{amount}}",
    "title": "Dépôt",
    "submit": "Déposer",
    "submitWithMethod": "Déposer avec {{method}}"
  },
  "feeDetails": {
    "amount": "Montant",
    "fee": "Frais de {{rate}}",
    "summaryAddedToCharge": "Les dépôts via {{method}} entraînent des frais de {{rate}} qui s’ajouteront au montant total débité.",
    "summaryDeductedFromDeposit": "Les dépôts via {{method}} entraînent des frais de {{rate}} qui seront déduits du montant que vous recevez.",
    "title": "Détail des frais",
    "totalCost": "Coût total",
    "youllGet": "Vous recevrez"
  },
  "fiat": {
    "agreeAndContinue": "Accepter les conditions et continuer",
    "amountLabel": "Montant du dépôt",
    "applePay": "Apple Pay",
    "applePayNotSetUp": "Ajoutez une carte à Apple Wallet, puis réessayez.",
    "applePayUnsupported": "Cet appareil ne peut pas payer avec Apple Pay.",
    "blocked": "Les dépôts ne sont pas disponibles dans votre région",
    "card": "Carte",
    "contactVerifyBoth": "Veuillez vérifier votre numéro de téléphone et votre adresse e-mail",
    "contactVerifyEmail": "Veuillez vérifier votre adresse e-mail",
    "contactVerifyPhone": "Veuillez vérifier votre numéro de téléphone",
    "countryHeading": "Votre pays",
    "countrySearchPlaceholder": "Rechercher",
    "delete": "Supprimer",
    "deposit": "Déposer",
    "depositReceived": "Dépôt de {{amount}} reçu",
    "depositReceivedFrom": "depuis {{method}}",
    "emailPlaceholder": "Votre adresse e-mail",
    "failure": "Dépôt échoué",
    "fee": "Frais de {{amount}}",
    "getNewPrice": "Obtenir un nouveau prix",
    "kycConsentCheck": "J’autorise Fun à vérifier mon identité et à en communiquer le résultat au prestataire de paiement qui traite ma commande. Consultez notre",
    "kycConsentPrompt": "En continuant, vous autorisez Fun à vérifier votre identité et à en communiquer le résultat au prestataire de paiement qui traite votre commande. Consultez notre",
    "kycConsentStop": ".",
    "kycDetailAddress": "Veuillez indiquer votre adresse",
    "kycDetailDob": "Veuillez saisir votre date de naissance",
    "kycDetailName": "Nous avons besoin de plus d'informations sur votre identité pour sécuriser votre dépôt.",
    "kycDetailNationality": "Votre nationalité",
    "kycDetailOther": "Veuillez fournir les informations restantes",
    "kycDetailSsn": "Veuillez indiquer votre SSN à 9 chiffres",
    "kycFileUnsupported": "Le téléchargement de documents n'est pas encore disponible ici — vous pourrez terminer cette étape bientôt.",
    "kycFormDetail": "Quelques informations sont nécessaires avant votre premier dépôt.",
    "kycFormInvalid": "Certaines de ces informations doivent être revues.",
    "kycPhoneInUse": "Ce numéro de téléphone est déjà utilisé avec un autre compte {{provider}}. Utilisez un autre numéro.",
    "kycTaxIdInUse": "Ce numéro fiscal est déjà utilisé avec un autre compte {{provider}}.",
    "kycFormMissing": "Certaines informations obligatoires manquent.",
    "kycFormStale": "Cette étape a changé. Vérifiez les informations ci-dessous.",
    "kycFormTitle": "Vérifiez votre identité",
    "kycIntroDetail": "Cela nous permet de traiter vos dépôts tout en gardant votre compte sécurisé. Cela ne prend qu’une minute et aucune pièce d’identité n’est requise.",
    "kycNoticeCountryCode": "Utilisez le code pays à deux lettres, comme AU",
    "kycNoticeDateFormat": "Utilisez le format AAAA-MM-JJ",
    "kycNoticeDatePast": "Saisissez une date passée",
    "kycNoticeInvalid": "Veuillez vérifier les champs surlignés",
    "kycNoticeRequired": "Veuillez remplir les champs surlignés",
    "kycNoticeUnderage": "Vous devez avoir au moins 18 ans pour continuer",
    "kycOnHold": "Vérification en attente",
    "kycOnHoldDetail": "Vous pouvez revenir et réessayer plus tard.",
    "kycOnHoldUntil": "Vous pourrez réessayer le {{date}}.",
    "kycOpenLink": "Continuer la vérification",
    "kycOptional": "facultatif",
    "kycPrivacyPolicy": "Politique de confidentialité",
    "kycProviderGeneric": "notre prestataire de paiement",
    "kycProviderGenericId": "notre partenaire de vérification",
    "kycProviderTerms": "conditions générales de {{provider}}",
    "kycProviderTermsPrompt": "En continuant, vous acceptez les",
    "kycRejected": "Vérification échouée",
    "kycRejectedSupport": "Contactez le support, nous allons vérifier.",
    "kycRequired": "Vérifier et déposer",
    "kycRequiredCta": "Vérification requise →",
    "kycRequiredDetail": "Terminez la vérification pour poursuivre votre dépôt.",
    "kycRequiredTitle": "Vérification d'identité requise",
    "kycCompleteDetail": "Votre limite de dépôt a été augmentée.",
    "kycCompleteTitle": "Vérification d’identité terminée",
    "kycHardCta": "Voir les options →",
    "kycHardDetail": "Nous ne pouvons pas augmenter votre limite de dépôt avec la vérification d’identité.",
    "kycHardTitle": "Impossible de vérifier votre identité",
    "kycPendingCta": "En attente de vérification →",
    "kycPendingDetail": "Nous travaillons à finaliser votre vérification au plus vite.",
    "kycPendingTitle": "Vérification d’identité en cours",
    "kycSoftCta": "Vérification requise →",
    "kycSoftDetail": "Vous pouvez réessayer pour corriger les problèmes de votre vérification.",
    "kycSoftTitle": "La vérification d’identité a échoué",
    "kycOptionCloseDetail": "Quittez et revenez à ce dépôt plus tard.",
    "kycOptionCloseTitle": "Fermer le dépôt",
    "kycOptionMaxDetail": "Jusqu’à {{max}} avant la vérification.",
    "kycOptionMaxDetailUnknown": "Jusqu’à votre limite actuelle avant la vérification.",
    "kycOptionMaxTitle": "Déposer le maximum",
    "kycOptionRedoDetail": "Confirmez vos informations et vos documents, puis réessayez.",
    "kycOptionRedoTitle": "Refaire la vérification d’identité",
    "kycOptionSupportDetail": "Contactez-nous pour résoudre les problèmes liés aux exigences de vérification d’identité.",
    "kycOptionSupportTitle": "Obtenir de l’aide",
    "kycOptionsHardTitle": "Nous ne pouvons pas augmenter votre limite de dépôt après la vérification d’identité.",
    "kycOptionsLabel": "Pour l’instant, vous pouvez :",
    "kycOptionsPendingTitle": "Votre vérification d’identité est toujours en cours de traitement. Vos limites de dépôt n’ont pas encore changé.",
    "kycOptionsSoftTitle": "Votre vérification d’identité a échoué. Réessayez pour corriger les problèmes de la dernière tentative.",
    "kycTitle": "Vérification d'identité",
    "otpDetailAnyEmail": "Code envoyé à votre adresse e-mail",
    "otpDetailAnyPhone": "Code envoyé à votre téléphone",
    "otpDetailEmail": "Code envoyé à {{email}}",
    "otpDetailPhone": "Code envoyé au {{phone}}",
    "otpError": "Ce code n'a pas fonctionné. Vérifiez-le et réessayez.",
    "otpExpired": "Ce code a expiré. Demandez-en un nouveau.",
    "otpRateLimited": "Trop de codes ont été demandés. Veuillez patienter avant de réessayer.",
    "otpRateLimitedTitle": "Veuillez patienter avant de demander un autre code",
    "otpPlaceholder": "Code à 6 chiffres",
    "otpResend": "Renvoyer",
    "otpResendPrompt": "Vous n'avez pas reçu le code ?",
    "otpTitle": "Saisissez le code",
    "payButton": "Déposer avec Apple Pay",
    "paySheetPay": "Payer",
    "paySheetTitle": "Confirmer avec Apple Pay",
    "paySheetTotal": "Total {{amount}}",
    "phoneCountryLabel": "Indicatif du pays",
    "phoneCountrySearch": "Rechercher un pays",
    "phonePlaceholder": "Votre numéro de téléphone",
    "processing": "Traitement de votre dépôt…",
    "pendingOrderTitle": "Vous avez un dépôt inachevé",
    "pendingOrderDetail": "Reprenez votre dépôt de {{amount}} ou annulez-le pour continuer avec un nouveau montant.",
    "resumeDeposit": "Reprendre le dépôt",
    "cancelDeposit": "Annuler le dépôt",
    "quoteExpired": "Ce prix a expiré",
    "quoteFailed": "Impossible d'obtenir le prix",
    "redirectDetail": "Nous mettrons cet écran à jour dès votre retour.",
    "redirectReopen": "Rouvrir le navigateur",
    "redirectTitle": "Terminez votre paiement dans le navigateur",
    "refunded": "Dépôt remboursé",
    "refusalDetails": "Vérifiez ce que vous avez saisi et réessayez.",
    "refusalDetailsTitle": "Certaines informations méritent une nouvelle vérification",
    "refusalLimits": "Essayez un montant plus faible ou un autre moyen de paiement.",
    "refusalLimitsTitle": "Ce moyen de paiement n'accepte pas ce montant",
    "refusalUnavailable": "Le problème vient de nous : réessayez dans un instant ou essayez un montant plus faible.",
    "refusalUnavailableTitle": "Aucune option de paiement n'est disponible pour le moment",
    "requote": "Obtenir une nouvelle cotation",
    "reviewTitle": "Confirmez votre dépôt",
    "orderConfirmingTitle": "Confirmation de votre paiement",
    "orderConfirmingDetail": "Votre paiement a été effectué. Nous enregistrons votre dépôt, cela peut prendre un instant.",
    "submitFailed": "L'envoi a échoué",
    "paymentFailed": "Veuillez réessayer",
    "submitting": "Envoi en cours",
    "stripeAuthDetail": "Nous utiliserons {{email}} pour continuer de façon sécurisée avec Link.",
    "stripeAuthorizing": "Continuer dans Stripe",
    "stripeAuthorizingDetail": "Terminez la vérification et le consentement Link dans la fenêtre Stripe.",
    "stripeAuthTitle": "Continuer avec Stripe",
    "stripeAuthFailed": "Nous n'avons pas pu démarrer votre session Stripe. Réessayez.",
    "stripeKycInfoFailed": "Impossible d'enregistrer vos informations auprès de Stripe. Vérifiez-les et réessayez.",
    "stripeRegistrationFailed": "Impossible de créer votre compte Link. Vérifiez vos informations et réessayez.",
    "success": "Dépôt terminé",
    "successDetail": "Votre solde sera mis à jour dans un instant.",
    "termsNotice": "En continuant, vous acceptez les\n<terms>Conditions</terms> du prestataire.",
    "unsupported": "Cette étape n'est pas encore disponible",
    "verifying": "Vérification de votre identité…",
    "verifyingDetail": "Cela prend généralement moins d'une minute.",
    "verifyingSlow": "Vérification en cours",
    "verifyingSlowDetail": "Vous pouvez fermer et revenir dans un instant.",
    "coinbaseTermsNotice": "En continuant, vous acceptez les\n<terms>Conditions</terms>, le <agreement>Contrat utilisateur</agreement> et la <privacy>Politique de confidentialité</privacy> de Coinbase.",
    "contactInvalidEmail": "Veuillez saisir une adresse e-mail valide",
    "kycIntroTitle": "Vérifions votre identité",
    "kycAdditionalTitle": "Il nous faut quelques infos de plus",
    "kycAdditionalDetail": "Une vérification supplémentaire est nécessaire pour augmenter vos limites de dépôt. Ces limites seront disponibles dès la vérification terminée.",
    "kycFindOutMore": "En savoir plus",
    "kycR2Consent": "En continuant, vous autorisez Fun à vérifier votre identité et à partager les résultats avec certains prestataires de paiement.",
    "kycAgreeContinue": "Accepter et continuer",
    "kycSsnLastFour": "Indiquez les 4 derniers\nchiffres de votre SSN",
    "kycSsnProtection": "La loi américaine nous impose de recueillir un SSN pour vérifier votre identité. Vos informations sont protégées par un chiffrement de niveau bancaire.",
    "kycDetailCountry": "Votre pays",
    "kycCountry": "Pays",
    "kycDetailOccupation": "Votre profession",
    "kycDetailPurpose": "Veuillez indiquer le motif de votre transaction",
    "kycOccupation": "Profession",
    "kycPurpose": "Motif de la transaction",
    "kycDetailPhone": "Votre numéro de mobile",
    "kycDetailEmployment": "Votre situation professionnelle",
    "kycDetailSourceOfWealth": "L’origine de votre patrimoine",
    "kycDetailIncome": "Vos revenus bruts annuels",
    "kycDetailActivity": "Votre activité mensuelle",
    "kycIncomeCaption": "Avant impôts, dans votre devise locale",
    "kycReviewTitle": "Merci ! Nous avons reçu vos informations et les examinons.",
    "kycHoldTitle": "Merci ! Nous avons reçu vos informations. Il nous faut un peu plus de temps pour terminer l’examen.",
    "kycRestrictedTitle": "Votre compte a été restreint.",
    "regionUnsupportedTitle": "Votre région n'est pas prise en charge.",
    "kycAnyQuestions": "Des questions ?",
    "kycGetHelpSupport": "Obtenir de l’aide et du support",
    "otpVerified": "Code vérifié",
    "authConnectFailedTitle": "Nous n'avons pas pu connecter votre compte {{provider}}",
    "authConnectFailedDetail": "Recommencez pour vous connecter depuis le début.",
    "kycUnavailableTitle": "La vérification est temporairement indisponible.",
    "kycUnavailableNetwork": "Réessayez dans un instant ou revenez plus tard.",
    "kycUnavailableProviderTitle": "Nous n’avons pas pu vous vérifier.",
    "kycUnavailableProvider": "Un problème est survenu de notre côté. Contactez l’assistance et nous prendrons le relais.",
    "contactSupport": "Contacter l’assistance",
    "kycDocumentTitle": "Vérification d’identité",
    "kycDocumentDetail": "Nous devons vérifier votre pièce d’identité pour finaliser votre vérification. La vérification d’identité est assurée par {{provider}}.",
    "kycDocumentContinue": "Vérifier l’identité avec {{provider}}",
    "applePayUnavailableTitle": "Apple Pay est temporairement indisponible.",
    "kycLimitNotice": "Limite quotidienne atteinte : vérifiez votre identité pour augmenter immédiatement vos limites.",
    "contactEmailRejected": "Cette adresse e-mail ne peut pas être vérifiée. Veuillez en choisir une autre.",
    "contactReverifyPhone": "Veuillez vérifier à nouveau votre numéro de téléphone.",
    "coinbaseCardSoftDeclined": "Votre banque a refusé ce paiement. Essayez une autre carte dans Apple Pay ou contactez votre banque.",
    "coinbaseCardHardDeclined": "Votre banque a refusé cette carte. Utilisez une autre carte dans Apple Pay.",
    "coinbaseCardRiskDeclined": "Ce paiement n'a pas pu être approuvé. Essayez une autre carte dans Apple Pay.",
    "coinbaseInvalidCard": "Vérifiez la carte et l'adresse de facturation dans Apple Pay, puis réessayez.",
    "coinbaseInsufficientBalance": "Cette carte n'a pas assez de fonds pour ce dépôt.",
    "coinbasePrepaidCard": "Les cartes prépayées ne sont pas acceptées. Utilisez une carte de débit dans Apple Pay.",
    "coinbaseRegionUnsupported": "Les dépôts par carte ne sont pas disponibles dans votre région.",
    "coinbasePermissionDenied": "Ce moyen de paiement n'est pas disponible sur votre compte.",
    "coinbaseWeeklyLimit": "Ce dépôt dépasserait votre limite hebdomadaire par carte. Essayez un montant plus petit.",
    "coinbaseLifetimeCount": "Vous avez utilisé tous les dépôts par carte disponibles sans compte Coinbase.",
    "coinbaseDailyCount": "Vous avez atteint la limite de dépôts par carte pour aujourd'hui. Réessayez demain.",
    "coinbaseBillingZip": "Le code postal de facturation ne correspond pas à votre carte. Vérifiez-le et réessayez.",
    "coinbaseBillingAddress": "L'adresse de facturation est incomplète. Vérifiez-la et réessayez.",
    "coinbaseBillingName": "Le nom du titulaire n'a pas été accepté. Vérifiez-le et réessayez.",
    "coinbaseSessionExpired": "Cette session de paiement a expiré. Recommencez le dépôt.",
    "coinbaseNetworkUnsupported": "Ce réseau n'est pas disponible dans votre région.",
    "coinbaseAssetUnsupported": "Ce token n'est pas disponible dans votre région.",
    "coinbaseProviderError": "Coinbase n'a pas pu finaliser l'opération. Réessayez dans un instant.",
    "coinbaseBuyFailed": "L'achat n'a pas pu être finalisé. Votre carte n'a pas été débitée.",
    "coinbaseSendFailed": "Le dépôt n'a pas pu être livré. Votre carte sera remboursée.",
    "coinbaseAvsFailed": "Votre adresse de facturation n'a pas pu être vérifiée. Vérifiez-la auprès de votre banque et réessayez.",
    "cancelled": "Dépôt annulé",
    "sessionExpired": "Votre session a expiré. Reconnectez-vous pour poursuivre le dépôt.",
    "accountIneligibleTitle": "Les dépôts ne sont pas disponibles pour ce compte",
    "accountIneligibleDetail": "Contactez le support si vous pensez qu'il s'agit d'une erreur."
  },
  "fops": {
    "bankTransferSubtitle": "Limite de {{limit}} · 1-2 jours",
    "bankTransferTime": "1-2 jours",
    "instant": "Instantané",
    "limit": "Limite de {{limit}}"
  },
  "networks": {
    "chainFallback": "Chaîne {{chainId}}",
    "minimum": "${{min}} minimum"
  },
  "qrCode": {
    "title": "Code QR"
  },
  "selectChain": {
    "subtitle": "Choisissez un réseau depuis lequel déposer",
    "title": "Déposer des cryptos"
  },
  "selectMethod": {
    "crypto": "Crypto",
    "depositTo": "Déposer sur",
    "errorMessage": "Un problème est survenu lors du chargement des données.\nVérifiez votre connexion internet et réessayez.",
    "errorTitle": "Une erreur est survenue",
    "loadingMethods": "Chargement des moyens de paiement",
    "noLimit": "Sans limite",
    "payWith": "Payer avec",
    "title": "Ajouter de l'argent"
  },
  "selectReceiveToken": {
    "availableTokens": "Jetons disponibles",
    "moreTokens_many": "+{{count}} jetons",
    "moreTokens_one": "+{{count}} jeton",
    "moreTokens_other": "+{{count}} jetons",
    "searchTokens": "Rechercher un jeton",
    "selectChain": "Sélectionnez le réseau",
    "selectToken": "Sélectionnez le jeton",
    "title": "Jeton et réseau de réception"
  },
  "transferCrypto": {
    "changeChain": "Changer de chaîne",
    "depositAddressLabel": "Votre adresse de dépôt",
    "generating": "Génération…",
    "selectedChain": "Chaîne sélectionnée",
    "share": "Partager",
    "shareAddress": "Partager l'adresse",
    "showQrCode": "Afficher le code QR",
    "title": "Transférer des cryptos"
  },
  "withdraw": {
    "belowMinimumMessage": "Votre solde est inférieur au minimum requis pour un retrait en espèces.",
    "belowMinimumTitle": "Solde insuffisant",
    "cashMethodsError": "Le chargement des méthodes de retrait en espèces a échoué. Vous pouvez toujours retirer en crypto.",
    "noCashMethods": "Les retraits par banque ou carte ne sont pas disponibles dans votre région. Vous pouvez toujours retirer en crypto.",
    "title": "Retirer",
    "unavailableMessage": "Les retraits en espèces ne sont pas disponibles dans votre région pour le moment.",
    "unavailableTitle": "Retraits indisponibles"
  },
  "withdrawAddress": {
    "breakdown": "Vous recevrez environ {{amount}}. Ce montant peut varier légèrement selon les conditions du réseau. Cette opération ne sera pas exécutée à un prix inférieur à {{minimum}}. Votre transaction devrait aboutir en quelques secondes.",
    "breakdownTitle": "Détail de la transaction",
    "clear": "Effacer",
    "detected": "Portefeuille détecté",
    "notFound": "Aucun portefeuille trouvé",
    "paste": "Coller",
    "requested": "Retrait demandé",
    "title": "Retirer {{amount}}",
    "useConnected": "Utiliser le connecté",
    "withdrawNow": "Retirer maintenant",
    "withdrawing": "Retrait en cours",
    "withdrew": "Retiré",
    "youllReceive": "Vous recevrez"
  },
  "withdrawAmount": {
    "amountLabel": "Montant",
    "delete": "Supprimer",
    "swapDenomination": "Basculer entre dollars et jetons",
    "useMax": "Tout utiliser"
  },
  "withdrawCrypto": {
    "aboveBalance": "Solde insuffisant",
    "addressPlaceholder": "Adresse du portefeuille",
    "available": "{{amount}} {{symbol}} disponibles",
    "belowFee": "Le montant doit être supérieur aux frais de {{amount}}",
    "belowMinimum": "Le montant minimum est de {{amount}}",
    "ctaInvalidForChain": "Adresse non valide sur ce réseau",
    "ctaMaxExceeded": "Montant maximum dépassé",
    "ctaRecipientSameAsSource": "Choisissez une autre adresse",
    "ctaSelectDestination": "Sélectionnez une destination",
    "errorGeneric": "Le retrait a échoué. Veuillez réessayer.",
    "errorInsufficientGas": "Gas insuffisant pour cette transaction.",
    "errorSwitchChain": "Impossible de changer de réseau. Assurez-vous que votre portefeuille prend en charge le réseau.",
    "failedMessage": "{{amount}} n'est pas parvenu au destinataire. Contactez le support si les fonds ne reviennent pas.",
    "failedTitle": "Le retrait n'a pas abouti",
    "max": "Max",
    "methodSubtitle": "Aucune limite",
    "methodTitle": "Adresse crypto",
    "quoteFailed": "Échec de la génération de la cotation. Veuillez réessayer.",
    "receiveAs": "Recevoir en",
    "refundedMessage": "{{amount}} a été renvoyé vers votre portefeuille.",
    "riskyAddress": "Cette adresse de portefeuille ne peut pas être utilisée en raison de restrictions.",
    "selectSource": "Sélectionner la source",
    "sendFrom": "Retirer depuis",
    "successPendingMessage": "{{amount}} est en cours de règlement on-chain. Vous pouvez fermer.",
    "successPendingTitle": "Retrait envoyé",
    "title": "Retirer des cryptos",
    "unsupportedRecipient": "Adresse du destinataire non prise en charge"
  },
  "withdrawLighter": {
    "delayHours": "{{hours}} h",
    "delayHoursMinutes": "{{hours}} h {{minutes}} min",
    "delayMinutes": "{{minutes}} min",
    "delaySecond": "1 seconde",
    "delaySeconds": "{{seconds}} secondes",
    "fastDisclaimer": "USDC Perps uniquement · Plusieurs chaînes · Instantané",
    "fastDisclaimerUnified": "USDC uniquement · Plusieurs chaînes · Instantané",
    "methodFast": "Rapide",
    "methodSecure": "Pont natif",
    "secureDisclaimer": "Tous les tokens · Chaîne Ethereum uniquement · {{delay}}",
    "secureFallbackDelay": "60+ minutes"
  },
  "withdrawNado": {
    "errorAmountTooLow": "Le montant est trop faible pour couvrir les frais de retrait Nado.",
    "errorBalanceChanged": "Votre solde retirable a changé. Appuyez sur Max et réessayez.",
    "errorInvalidNonce": "Cette demande de retrait a expiré. Veuillez réessayer.",
    "errorNetwork": "Impossible de joindre Nado pour le moment. Veuillez réessayer.",
    "errorNoPriorDeposit": "Déposez sur Nado avant de retirer.",
    "errorRateLimited": "Trop de requêtes. Veuillez patienter un instant et réessayer.",
    "errorSignerMismatch": "Revenez au portefeuille propriétaire de ce compte Nado pour retirer.",
    "errorUnconfirmed": "Nous n'avons pas pu confirmer votre retrait. Vérifiez votre solde Nado avant de réessayer.",
    "errorWithdrawRisk": "La limite de retrait sur 24 heures de Nado a été atteinte. Veuillez réessayer plus tard."
  },
  "paymentMethods": {
    "applePay": "Apple Pay",
    "card": "Carte"
  },
  "lockedTransfer": {
    "amountInfoTitle": "Montant à envoyer",
    "amountInfoDescription": "Voici le montant à envoyer pour déposer {{amount}}. Les fonds envoyés au-delà de ce montant ne seront pas déposés et nécessiteront l’aide du support pour être récupérés.",
    "amountLoading": "Calcul en cours…",
    "amountUnavailable": "Montant indisponible",
    "title": "Déposer des cryptos",
    "send": "Envoyer",
    "amount": "Montant",
    "address": "Adresse de dépôt à usage unique",
    "copyAmount": "Copier le montant",
    "amountCopied": "Montant copié",
    "showFullAddress": "Afficher l'adresse complète",
    "tokenOnChain": "{{token}} sur {{chain}}"
  },
  "selectAsset": {
    "emptyChains": "Aucun réseau compatible disponible",
    "combinedTitle": "Jeton et réseau à envoyer",
    "title": "Sélectionnez un actif",
    "empty": "Aucun actif pris en charge disponible"
  }
}
